import React from 'react';
import { JsonLdScript } from 'components/atoms';

const webSiteSchema = {
	'@context': 'https://schema.org',
	'@type': 'WebSite',
	name: 'SelfStorage.com',
	url: 'https://www.selfstorage.com/',
	potentialAction: {
		'@type': 'SearchAction',
		target: 'https://www.selfstorage.com/search?location={search_term_string}',
		'query-input': 'required name=search_term_string',
	},
	sameAs: [
		'https://www.linkedin.com/company/selfstorage.com',
		'https://twitter.com/selfstorageinc',
		'https://www.facebook.com/SelfStorageInc',
		'https://www.youtube.com/user/SelfStorageCom',
	],
};

export function WebSiteSchema() {
	return <JsonLdScript schema={webSiteSchema} />;
}

export default WebSiteSchema;
